import { useState, useEffect } from "react";
import "./pricing.css";
import { Button } from "react-bootstrap";

const DesktopPairType = ({
  pricestepData,
  setPricestepData,
  setDisableSelect,
  from,
  reportType
}) => {
  const [activeTab, setActiveTab] = useState(false);
  const [activeTabName, setActiveTabName] = useState("single");
  // console.log("reportType", reportType);
  const handleTab = (name) => {

    // if (
    //   !pricestepData?.colorUndertone
    // ) {
    //   if (from === "desktop") {
    //     setDisableSelect(true);
    //   }
    //   return;
    // }

    setActiveTab(!activeTab);
    const text = activeTab ? "single" : "pair";

    setActiveTabName(text);
    setPricestepData({ ...pricestepData, singlePair: text });
  };

  const basicMode = localStorage.getItem("checkAssets")==="true" || pricestepData?.saturation ==="Fancy Deep";

  useEffect(() => {
    if (pricestepData?.singlePair === "pair") {
      handleTab("pair");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleKey = (e) => {
    switch (e.key) {
      case "ArrowRight":
        handleTab("pair");
        break;
      case "ArrowLeft":
        handleTab("single");
        break;
      // case "Enter":
      //   handleTab("pair");
        // break;
      default:
        break;
    }
   
  };

  return (
    <div className="tab-btns-wrapper">
      <input
        className="single-pair-check"
        type="checkbox"
        id="checkbox_toggle"
        checked={activeTab}
      />
      <Button
        className={`single-pair-checkbox ${
          !pricestepData?.singlePair ? "disable_pair_border" : ""
        }`}
        onClick={() => handleTab("single")}
        onKeyDown={handleKey}
        disabled={basicMode ?  !pricestepData?.colorUndertone : !pricestepData?.trueFaceUp}
      >
        <label htmlFor="checkbox_toggle" className="single-pair-slide">
          <label
            htmlFor="checkbox_toggle"
            className={`single-pair-toggle  ${
              !pricestepData?.singlePair ? "pair-disabled" : ""
            }`}
          ></label>
          <label
            htmlFor="checkbox_toggle"
            className={`single-pair-text ${
              activeTabName === "single" ? " single" : ""
            }`}
            onClick={() => handleTab("single")}
          >
            single
          </label>
          <label
            htmlFor="checkbox_toggle"
            className={`single-pair-text ${
              activeTabName === "pair" ? "pair" : ""
            }`}
            onClick={() => handleTab("pair")}
          >
            pair
          </label>
        </label>
      </Button>
    </div>
  );
};

export default DesktopPairType;
